import React from "react";
import Carousel from "react-bootstrap/Carousel";

function Carousellims() {
  return (
    <div>
      <Carousel fade style={{ zIndex: "-1", marginTop: "-9rem" }}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/lims1.jpeg"
            alt="First slide"
          />
          <Carousel.Caption>
            <h2 style={{ color: "white" }}>Medals</h2>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/lims2.jpeg"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h2 style={{ color: "white" }}>Primary Kids Wearing Medals</h2>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/lims3.jpeg"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h2 style={{ color: "white" }}>Girls Praying</h2>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Carousellims;
